import styled from '@emotion/styled';

import logo from '@/images/did_logo_dark.svg';

const Container = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
    margin-bottom: 32px;
`;

const StyledIcon = styled('img')`
    width: 6.4rem;

    @media (max-width: 600px) {
        max-width: 4rem;
        max-height: 4rem;
    }
`;

export default function NewHeader() {
    return (
        <Container>
            <StyledIcon src={logo} />
        </Container>
    );
}
